const BANKID_MODES = {
	RETRIEVE_BALANCE: 'retrive-balance',
	SWISH: 'swish',
	LOGIN: 'login',
	REGISTER: 'register',
	PLAY_NOW: 'play-now'
};

const GUEST_FRANCHISE_MODES = [BANKID_MODES.RETRIEVE_BALANCE, BANKID_MODES.SWISH];

const REGISTRATION_MODES = [
	BANKID_MODES.RETRIEVE_BALANCE,
	BANKID_MODES.SWISH,
	BANKID_MODES.REGISTER,
	BANKID_MODES.PLAY_NOW
];

const LOGO_DESKTOP_MODES = [BANKID_MODES.SWISH];

const BANKID_INFO_MODES = [BANKID_MODES.PLAY_NOW];
const BANKID_TERMS_MODES = [BANKID_MODES.REGISTER];

const BANKID_SCREEN = {
	FORM: 'form',
	BASIC: 'basic',
	MIDDLE_SCREEN: 'middle-screen',
	QR: 'QR'
};

export {
	BANKID_INFO_MODES,
	BANKID_MODES,
	BANKID_SCREEN,
	BANKID_TERMS_MODES,
	GUEST_FRANCHISE_MODES,
	LOGO_DESKTOP_MODES,
	REGISTRATION_MODES
};
